export default "__VITE_ASSET__DFyWD725__"